module.exports = __webpack_public_path__ + "static/airscope-b34eb1f621dd696792efd17331eedaff.png";